export const QueryKey = 'lab-orders'
export const LabOrders = '/api/v1/lab-orders'
